import type NavigationMenu from "./navigation.model";

export type SideBarMode = 'opened' | 'closed' | 'hovered';


export let navigation: NavigationMenu [] = [
  {
    type: 'group',
    id: 'application',
    title: 'Application',
    translate: 'main.menu.application',
    children: [
      /*{
        type: 'dashboard',
        id: 'main',
        title: 'Main',
        icon: 'dashboard',
        url: 'dashboard',
        translate: 'main.menu.dashboard',
      },*/
      {
        type: 'item',
        id: 'control-tower',
        title: 'Control Tower',
        translate: 'main.menu.ct',
        icon: 'map',
        url: 'control-tower'
      },
      {
        type: 'item',
        id: 'shipments',
        title: 'Shipments',
        icon: 'directions_boat',
        url: 'shipments',
        translate: 'main.menu.shipment'
      },
/*      {
        type: 'item',
        id: 'file-import',
        title: 'File Import',
        translate: 'main.menu.file',
        url: 'file-import',
        icon: 'insert_drive_file'
      },*/
      {
        type: 'item',
        id: 'plans',
        title: 'Planed list',
        translate: 'main.menu.plan',
        icon: 'alt_route',
        url: 'plans'
      },
      {
        type: 'item',
        id: 'eta',
        title: 'ETA',
        translate: 'main.menu.eta',
        icon: 'schedule',
        url: '/eta'
      },
      {
        type: 'item',
        id: 'eta-report',
        title: 'ETA Report',
        translate: 'main.menu.eta-report',
        icon: 'pending_actions',
        url: '/eta-report'
      },
      {
        type: 'item',
        id: 'eta-scm-report',
        title: 'ETA SCM Report',
        translate: 'main.menu.eta.report.scm',
        icon: 'pending_actions',
        url: '/eta-scm-report',
      },
      {
        type: 'collapsable',
        id: 'help',
        title: 'Help',
        translate: 'main.menu.help',
        icon: 'contact_support',
        children:[
/*          {
            type: 'item',
            id: 'user-manual',
            title: 'User Manual',
            translate: 'main.menu.manual',
            //icon: 'contact_support',
            url: 'user-manual',
          },*/
          {
            type: 'item',
            id: 'faq',
            title: 'FAQ',
            translate: 'main.menu.faq',
            //icon: 'contact_support',
            url: 'faq'
          },
          {
            type: 'item',
            id: 'contact',
            title: 'contact Us',
            translate: 'main.menu.contact',
            //icon: 'contact_support',
            url: 'contact-us',
            // launch: ContactUsComponent
          }
        ]
      },
      /*{
        type: 'collapsable',
        id: 'reports',
        title: 'Reports',
        translate: 'main.menu.reports',
        icon: 'report',
        children: [
          {
            type: 'item',
            id: 'deviations',
            title: 'Deviations',
            translate: 'main.menu.deviations',
            //icon: 'warning',
            url: '/deviations'
          },
          {
            type: 'item',
            id: 'eta',
            title: 'ETA',
            translate: 'main.menu.eta',
            url: '/eta'
          }
        ]
      }*/
    ]
  }
];

export const navigationAdmin: NavigationMenu [] = [
  {
    type: 'collapsable',
    id: 'admin',
    title: 'Admin',
    translate: 'main.menu.admin',
    icon: 'admin_panel_settings',
    children: [
      {
        type: 'item',
        id: 'test-map',
        title: 'Test Map',
        url: 'admin/test-map'
      },
      {
        type: 'item',
        id: 'status',
        title: 'Status',
        translate: 'main.menu.status',
        url: 'admin/statuses'
      },
      {
        type: 'item',
        id: 'carriers',
        title: 'Carriers',
        translate: 'main.menu.carrier',
        url: 'admin/carriers'
      },
      {
        type: 'item',
        id: 'users',
        title: 'Users',
        translate: 'Users',
        url: 'admin/users'
      },
      {
        type: 'item',
        id: 'customers',
        title: 'Customers',
        url: 'admin/customers'
      },
      {
        type: 'item',
        id: 'traces',
        title: 'Traces',
        translate: 'Traces',
        url: 'admin/traces'
      },
      {
        type: 'item',
        id: 'filters',
        title: 'Filters',
        url: 'admin/filters'
      },
      {
        type: 'item',
        id: 'admin-containers',
        title: 'Containers',
        url: 'admin/containers'
      },
      {
        type: 'item',
        id: 'admin-edi',
        title: 'EDI',
        url: 'admin/edi'
      },
      {
        type: 'item',
        id: 'admin-company-config',
        title: 'Company Config',
        url: 'admin/company-config'
      },
      {
        type: 'item',
        id: 'admin toggles',
        title: 'Admin toggles',
        url: 'admin/toggles'
      },
      {
        type: 'item',
        id: 'cargo-cube',
        title: 'Cargo Cube',
        url: 'admin/cargo-cube'
      },
      {
        type: 'item',
        id: 'company-time-offset',
        title: 'Company Time Offset',
        url: 'admin/company-time-offsets'
      }
    ]
  },
  {
    type: 'collapsable',
    id: 'reports',
    title: 'Reports',
    translate: 'main.menu.reports',
    icon: 'report',
    children: [
      {
        type: 'item',
        id: 'deviations',
        title: 'Deviations',
        translate: 'main.menu.deviations',
        //icon: 'warning',
        url: '/deviations'
      },
      {
        type: 'item',
        id: 'eta',
        title: 'ETA',
        translate: 'main.menu.eta',
        url: '/eta'
      }
    ]
  }]
